import Errors from "./Errors";

class Form extends Errors {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   */
  constructor(data) {
    super();
    this.showPassword = false;
    this.passwordType = "password";
    this.originalData = data;

    for (let field in data) {
      this[field] = data[field];
    }
  }

  /**
   * Fetch all relevant data for the form.
   */
  data() {
    let data = {};

    for (let property in this.originalData) {
      data[property] = this[property];
    }

    return data;
  }

  /**
   * Reset the form fields.
   */
  reset() {
    for (let field in this.originalData) {
      this[field] = "";
    }

    this.clear();
  }

  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   * @param {object} extra data to send with form data
   */
  post(url, extra) {
    return this.submit("post", url, extra);
  }

  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   * @param {object} extra data to send with form data
   */
  put(url, extra) {
    return this.submit("put", url, extra);
  }

  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   * @param {object} extra data to send with form data
   */
  patch(url, extra) {
    return this.submit("patch", url, extra);
  }

  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   * @param {object} extra data to send with form data
   */
  delete(url, extra) {
    return this.submit("delete", url, extra);
  }

  /**
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   * @param {object} extra data to send with form data
   */
  submit(requestType, url, extra) {
    this.clear();
    return new Promise((resolve, reject) => {
      axios[requestType](url, { ...this.data(), ...extra })
        .then(response => {
          this.onSuccess(response.data);
          resolve(response.data);
        })
        .catch(error => {
          let data = error.response.data;
          if (data.message === "CSRF token mismatch.") {
            return window.location.reload();
          }
          this.onFail(data.errors);
          if (data.token) {
            window.axios.defaults.headers.common["X-CSRF-TOKEN"] = data.token;
          }
          reject(data.errors);
        });
    });
  }

  /**
   * Toggle's the password's input:type
   * */
  togglePassword() {
    this.showPassword = !this.showPassword;
    this.passwordType = this.showPassword ? "text" : "password";
    document.getElementById("password").focus();
  }

  /**
   * Is form have any empty input's.
   *
   * @return {boolean} is form empty yet ?
   */
  isEmpty() {
    let empty = [];

    for (let property in this.originalData) {
      empty.push(this[property] === "");
    }

    return empty.every(e => e);
  }

  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess(data) {
    this.reset();
  }

  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    this.record(errors);
  }
}

export default Form;
